import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { changePasswordValidationForm } from '../../utils/validationSchema';
import Button from '../Reusable/Button';
import PasswordField from '../Reusable/Form/PasswordInput';
import APIS from '../../constant/EndPoint';
import usePostHook from '../../customHooks/useUserServicePostHook';

const ChangePassword = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError
  } = useForm<any>({
    resolver: yupResolver(changePasswordValidationForm),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["."],
    navigateURL: "",
  });
  console.log(props)
  const handleChangePassword = async (values: any, setError: any) => {
    const url = `${APIS.CHANGE_PASSWORD}`;
    let formData = {
      ...values,
      email: props?.user?.email ?? props?.profile?.email
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        props?.setOpenChangePasswordPopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <>
      <PasswordField
        register={register("password")}
        label={"New Password"}
        errors={errors?.password}
      />
      <PasswordField
        register={register("confirm_password")}
        label={"Confirm New Password"}
        errors={errors?.confirm_password}
      />
      <Button
        type={"button"}
        isLoading={isPostLoading}
        label={"Change Password"}
        onClick={handleSubmit((data: any) =>
          handleChangePassword(data, setError)
        )}
      />
    </>
  )
}

export default ChangePassword
